import * as React from 'react';
import classnames from 'classnames';
import { useProductPromotionEventContext } from '../utils/DataLayer/Contexts/ProductPromotionEventContext.js';
import { useGetProductsBySku } from '../utils/use-get-products-by-sku.js';
import { ProductBanner as ProductBanner$1 } from './ProductBanner/ProductBanner.js';

const ProductBannerContainer = ({ skus , formatProductUrl , className  })=>{
    const { isLoading , products , error  } = useGetProductsBySku(skus);
    const classNames = classnames('product-banner', className);
    const { trackImpression , trackInteraction  } = useProductPromotionEventContext();
    return /*#__PURE__*/ React.createElement(ProductBanner$1, {
        products: products,
        formatProductUrl: formatProductUrl,
        isLoading: isLoading,
        error: error,
        className: classNames,
        onProductImpression: trackImpression,
        onProductInteraction: trackInteraction
    });
};
var ProductBanner = ProductBannerContainer;

export { ProductBannerContainer, ProductBanner as default };
//# sourceMappingURL=ProductBannerContainer.js.map
